import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

function CTASection() {
  const { t } = useTranslation()
  
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-6">
          {t('cta.title')}
        </h2>
        <p className="text-xl text-gray-600 mb-8">
          {t('cta.subtitle')}
        </p>
        <Link
          to="/register"
          className="inline-block bg-blue-600 text-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-blue-700 transition-colors shadow-lg hover:shadow-xl"
        >
          {t('cta.button')}
        </Link>
      </div>
    </section>
  )
}

export default CTASection